import create from "zustand";

const useDocFormsStore = create((set) => ({
  templates: [],
  setTemplates: (templates) => set({ templates }),
  addTemplate: (template) =>
    set((state) => ({
      templates: [...state.templates, template],
    })),
  removeTemplate: (id) =>
    set((state) => ({
      templates: state.templates.filter((t) => t.id !== id),
    })),

  completedForms: [],
  setCompletedForms: (forms) => set({ completedForms: forms || [] }),
  addCompletedForm: (form) =>
    set((state) => ({
      completedForms: [...state.completedForms, form],
    })),
  removeCompletedForm: (id) =>
    set((state) => ({
      completedForms: state.completedForms.filter((f) => f.id !== id),
    })),

  assignedForms: [],
  setAssignedForms: (forms) => set({ assignedForms: forms || [] }),
  addAssignedForm: (form) =>
    set((state) => ({
      assignedForms: [...state.assignedForms, form],
    })),
  removeAssignedForm: (id) =>
    set((state) => ({
      assignedForms: state.assignedForms.filter((f) => f.id !== id),
    })),

  archiveForms: [],
  setArchiveForms: (forms) => set({ archiveForms: forms || [] }),
  addArchiveForm: (form) =>
    set((state) => ({
      archiveForms: [...state.archiveForms, form],
    })),
  removeArchiveForm: (id) =>
    set((state) => ({
      archiveForms: state.archiveForms.filter((f) => f.id !== id),
    })),

  loading: false,
  setLoading: (loading) => set({ loading }),
}));

export default useDocFormsStore;
